import React from 'react';
import { useSelector } from 'umi';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { pcPageConfig } from './pcPageConfigNew'; 

const reqParams = '/monetization/salesBreakdown';
const SalesBreakdown = () => {
  const dataFrame = useSelector((state: any) => state?.dashboard?.currentGame?.data_frame || 'mobile');
  const pageMap: any = {
    pc: pcPageConfig,
  };
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={pageMap?.[dataFrame]} />
    </>
  );
};

export default SalesBreakdown;